<template>
  <div class="container my-3 bg-transparent">
    <div
      class="alert alert-danger"
      role="alert"
    ><h5>La page que vous cherchez à atteindre n'existe pas !</h5></div>
  </div>
</template>

<script>
export default {
  name: "Error",
};
</script>
